import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { FollowUpModel } from '../model/index';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class BackupFollowUpClientService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });

    private Url = 'api/followUpClientUpload';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBackupFollowUpClientList(query: any): Promise<FollowUpModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/backupFollowUpClientList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    changeExistingClientFollowup(param: any): Promise<any> {
        const url = `${this.Url}/changeExistingClientFollowup`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    saveFile(query: any): Promise<any> {
        const url = `${this.Url}/saveDetails`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<FollowUpModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/backupFollowUpClient.service.ts